import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { LoginComponent } from './components/login.component';
import { HomeComponent } from './components/home.component';
import { ProductsComponent } from './components/products.component';
import { ProductComponent } from './components/product.component';
import { CustomersComponent } from './components/customers.component';
import { CustomerComponent } from './components/customer.component';
import { VendorsComponent } from './components/vendors.component';
import { VendorComponent } from './components/vendor.component';
import { SalesOrdersComponent } from './components/salesorders.component';
import { SalesOrderComponent } from './components/salesorder.component';
import { SalesInvoicesComponent } from './components/salesinvoices.component';
import { SalesInvoiceComponent } from './components/salesinvoice.component';
import { ProformasComponent } from './components/proformas.component';
import { ProformaComponent } from './components/proforma.component';
import { PurchaseOrdersComponent } from './components/purchaseorders.component';
import { PurchaseOrderComponent } from './components/purchaseorder.component';
import { SearchResultsComponent } from './components/search-results.component';

export const routes: Routes = [
  {
    path: '',
    component: LoginComponent
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'search',
    component: SearchResultsComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'products',
    component: ProductsComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'products/new',
    component: ProductComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'products/:id',
    component: ProductComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'customers',
    component: CustomersComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'customers/new',
    component: CustomerComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'customers/:id',
    component: CustomerComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'vendors',
    component: VendorsComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'vendors/new',
    component: VendorComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'vendors/:id',
    component: VendorComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'orders',
    component: SalesOrdersComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'orders/new',
    component: SalesOrderComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'orders/:id',
    component: SalesOrderComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'purchase-orders',
    component: PurchaseOrdersComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'purchase-orders/new',
    component: PurchaseOrderComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'purchase-orders/:id',
    component: PurchaseOrderComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'sales-invoices',
    component: SalesInvoicesComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'sales-invoices/new',
    component: SalesInvoiceComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'sales-invoices/:id',
    component: SalesInvoiceComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'proformas',
    component: ProformasComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'proformas/new',
    component: ProformaComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'proformas/:id',
    component: ProformaComponent,
    canActivate: [MsalGuard]
  }
];
